import React from "react";

// Recharts' default tooltip is styled for a light background - this themes
// it to match the app's dark card surfaces. Shared across chart pages.
const ThemedTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div
      style={{
        backgroundColor: "var(--bg-elevated-2)",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius-sm)",
        padding: "8px 12px",
        fontSize: "0.85rem",
        color: "var(--text-primary)",
      }}
    >
      {label && (
        <div className="mb-1" style={{ color: "var(--text-secondary)" }}>
          {label}
        </div>
      )}
      {payload.map((entry) => (
        <div key={entry.dataKey || entry.name} style={{ color: entry.color }}>
          {entry.name}: {entry.value?.toLocaleString?.() ?? entry.value}
        </div>
      ))}
    </div>
  );
};

export default ThemedTooltip;
